import { REQUEST } from 'crom-api-constants'

export const FORM_ID = 'editProfile'
export const FIELD = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
}

export const SUBMIT_USER_DATA_FORM = 'SUBMIT_USER_DATA_FORM'
export const UPDATE_USER_DATA_REQUEST = `UPDATE_USER_DATA_${REQUEST}`
export const RELOAD_UPDATE_USER_DATA_REQUEST = `RELOAD_UPDATE_USER_DATA_${REQUEST}`

export const EMAIL_REGEX =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i // eslint-disable-line max-len, no-useless-escape

export const LOCALE_PREFIX =
    'components.Dialog.components.UserProfile.components.Content.components.EditProfile.components.EditProfileForm'
